import { render, staticRenderFns } from "./ReferralHistoryComponent.vue?vue&type=template&id=090695c1"
import script from "./ReferralHistoryComponent.vue?vue&type=script&lang=js"
export * from "./ReferralHistoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports